import React from "react";
import { Editor } from "../Editor";
import { classNames } from "primereact/utils";
import { highlightSearchTerm } from "../../utils/searchHighlight";
import styles from "./SearchHighlightedEditor.module.css";

interface SearchHighlightedEditorProps {
  content: string;
  onChange: (value: string) => void;
  modules: any;
  placeholder?: string;
  className?: string;
  searchTerm?: string;
}

export const SearchHighlightedEditor: React.FC<
  SearchHighlightedEditorProps
> = ({ content, onChange, modules, placeholder, className, searchTerm }) => {
  const hasMatch =
    searchTerm &&
    content &&
    stripHTML(content).toLowerCase().includes(searchTerm.toLowerCase());

  return (
    <div className={styles.searchHighlightedEditorWrapper}>
      <Editor
        content={content}
        onChange={onChange}
        modules={modules}
        placeholder={placeholder}
        className={classNames(className, { "search-highlight": hasMatch })}
      />

      {/* Show highlighted preview below editor when there's a match */}
      {hasMatch && (
        <div className={styles.searchHighlightPreview}>
          <small className="text-primary font-bold">
            ✓ Search matches in content:
          </small>
          <div className={styles.highlightedContentPreview}>
            {highlightSearchTerm(stripHTML(content), searchTerm)}
          </div>
        </div>
      )}
    </div>
  );
};

// Function to strip HTML tags and get plain text
function stripHTML(html: string): string {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");
  return doc.body.textContent || "";
}
